import React, { useState } from 'react'
import { motion } from 'framer-motion'
import { usePopper } from 'react-popper'
import type { Placement } from '@popperjs/core'
import { useBreakpoint } from 'gatsby-plugin-breakpoints'
import CallToAction from './CallToAction'

export const Block = ({
    title,
    children,
    cta,
}: {
    title: string
    children: React.ReactNode
    cta: { url: string; label: string; enable: string }
}) => {
    if (
        (cta?.enable === false || cta?.enable?.toLowerCase?.() === 'false') &&
        !process.env.RENDER_DISABLED_COMPONENTS
    ) {
        cta = null
    }
    return (
        <div className="flex flex-col py-6 md:px-6 xl:px-9">
            <div className="mb-4">
                <h3 className="mt-0 mb-2 text-[18px] font-bold text-black/70">{title}</h3>
                <div>{children}</div>
            </div>
            {cta && (
                <CallToAction to={cta.url} className="mt-auto !w-full">
                    {cta.label}
                </CallToAction>
            )}
        </div>
    )
}

interface IColumnProps {
    title: string
    cta: {
        url: string
        label: string
    }
    children: React.ReactNode
}

export const TwoCol = ({ left, right }: { left: IColumnProps; right: IColumnProps }) => {
    console.log('TwoCol left', left)
    console.log('TwoCol right', right)
    return (
        <div className="border-t border-dashed border-gray-accent-light">
            <div className="xl:max-w-auto mx-auto grid max-w-3xl divide-y divide-dashed divide-gray-accent-light sm:grid-cols-2 sm:divide-x sm:divide-y-0">
                <Block title={left?.title} cta={left?.cta}>
                    {left?.children}
                </Block>
                <Block title={right?.title} cta={right?.cta}>
                    {right?.children}
                </Block>
            </div>
        </div>
    )
}

export function Wrapper({
    className = '',
    children,
    placement = 'bottom-start',
    referenceElement,
    borderRadius = '0.375rem',
}: {
    className?: string
    children: React.ReactNode
    placement: Placement
    referenceElement: HTMLDivElement
    borderRadius?: string | number
}) {
    const [popperElement, setPopperElement] = useState<HTMLDivElement | null>(null)
    const breakpoints = useBreakpoint()
    const { styles, attributes } = usePopper(referenceElement, popperElement, {
        placement,
    })
    const variants = {
        hidden: { height: 0 },
        shown: { height: 'auto' },
    }
    return (
        <div
            className={className}
            ref={setPopperElement}
            style={!breakpoints.md ? styles.popper : {}}
            {...attributes.popper}
        >
            <div className="relative top-0 z-10 text-almost-black lg:block">
                <motion.div
                    style={{ borderRadius }}
                    className="overflow-hidden bg-white dark:bg-gray-accent-dark md:mt-6 lg:my-0 lg:shadow-lg"
                    variants={variants}
                    initial="hidden"
                    animate="shown"
                >
                    {children}
                </motion.div>
            </div>
        </div>
    )
}
